module.exports = __webpack_public_path__ + "static/media/banana1.01e9ab0d.png";